export const config = {
  title: 'True Color Painting and More | Residential & Commercial Painting in Lorain, OH',
  meta: {
    description:
      'True Color Painting and More provides expert interior and exterior painting, drywall repair, power washing, and remodeling services in Lorain, OH and surrounding areas.',
    keywords: [
      'True Color Painting and More',
      'Interior Painting',
      'Exterior Painting',
      'Commercial Painting',
      'Drywall Repair',
      'Power Washing',
      'Home Remodeling',
      'Painter Lorain OH',
    ],
    author: 'True Color Painting and More',
    canonicalUrl: 'https://tcolorpainting.com/',
  },
  sections: {
    header: {
      businessName: 'True Color Painting and More',
    },
    sectionB: {
      heroTitle: 'True Color Painting and More',
      heroSubtitle: 'Professional Painting and Remodeling in Lorain, OH',
      learnAboutText: 'Explore Our Services',
      phoneNumber: '14402220771',
      phoneLabel: '+1 (440) 222-0771',      
      heroBackgroundImage:
        'https://images.pexels.com/photos/1561020/pexels-photo-1561020.jpeg',
      cardData: [
        {
          title: 'Interior & Exterior Painting',
          description:
            'We transform your home or business with high-quality painting and color consulting services.',
        },
        {
          title: 'Drywall & Power Washing',
          description:
            'From expert drywall repairs to powerful exterior cleaning, we’ve got your surfaces covered.',
        },
        {
          title: 'Home Remodeling',
          description:
            'Upgrade your property with our skilled remodeling and improvement solutions.',
        },
      ],
      description:
        'True Color Painting and More is a locally trusted painting and remodeling company serving Lorain, OH. We specialize in high-quality finishes, detailed craftsmanship, and professional service you can rely on.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'From vibrant painting to complete home remodeling, we deliver premium results with care and precision.',
      cards: [
        {
          title: 'Interior Painting',
          description:
            'Custom color solutions and professional painting for walls, ceilings, trim, and more.',
          imageSrc: 'https://media.istockphoto.com/id/1007607572/photo/man-painting-interior-of-home-by-window.jpg?s=612x612&w=0&k=20&c=x2ryNmZsEdZVPIEQ0HpWHVo973uJga5dy4KU3ivkdu4=',
          imageAlt: 'Interior Painting',
        },
        {
          title: 'Exterior Painting',
          description:
            'Durable and vibrant exterior painting to boost your curb appeal and protect your home.',
          imageSrc: 'https://media.istockphoto.com/id/134248179/photo/construction-working-putting-plaster-on-a-wall.jpg?s=612x612&w=0&k=20&c=O2dRTQiLTt30Yo0H0drST9o47-CAU_stUhrUn-2b6-A=',
          imageAlt: 'Exterior Painting',
        },
        {
          title: 'Drywall Repair & Power Washing',
          description:
            'Smooth finishes and clean surfaces with our drywall and power washing services.',
          imageSrc: 'https://media.istockphoto.com/id/2154982901/photo/worker-is-applying-skim-coating-material-to-the-wall-before-painting.jpg?s=612x612&w=0&k=20&c=iZ877Vls9Z0QJlP8g4zYh2nMElSAK0NP0s7Z1PV0WO0=',
          imageAlt: 'Drywall and Power Washing',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Home Remodeling',
        'Deck & Fence Painting',
        'Color Consultation',
        'Garage Coatings',
        'Trim & Cabinet Painting',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://images.pexels.com/photos/994164/pexels-photo-994164.jpeg',
        alt: 'True Color Painting and More Team',
      },
      aboutText: [
        'True Color Painting and More is a family-owned company with a passion for transforming spaces. Based in Lorain, OH, we proudly serve homeowners and businesses with expert painting and remodeling solutions.',
        'We value professionalism, cleanliness, and reliability—ensuring every project is finished on time and to your satisfaction.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'True Color Painting and More Logo',
      businessName: 'True Color Painting and More',
      contact: {
        phone: '14402220771',
        phoneLabel: '+1 (440) 222-0771',
        email: 'cooperrayon94@gmail.com',
        website: 'https://tcolorpainting.com/',
        address: '931 South Central Drive, Lorain, OH 44052, US',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        linkedin: null,
        twitter: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '931 South Central Drive, Lorain, OH 44052, US',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2960.184750000001!2d-82.15935038455583!3d41.43892417925856!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x883096d0dfb535bb%3A0x1234567890abcdef!2s931%20S%20Central%20Dr%2C%20Lorain%2C%20OH%2044052%2C%20USA!5e0!3m2!1sen!2sus!4v1712105000000!5m2!1sen!2sus',
    },
  },
};

export default config;
